// New changes to fix raiting issue changed on 28th August

// import React, { useEffect, useState } from 'react'
// import StarIcon from '@mui/icons-material/Star';
// import { teal } from '@mui/material/colors';
// import { Box, Button, Divider, Grid, IconButton, LinearProgress, Modal, Rating, Snackbar, Alert } from '@mui/material';
// import ShieldIcon from '@mui/icons-material/Shield';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import { Wallet } from '@mui/icons-material';
// import RemoveIcon from '@mui/icons-material/Remove';
// import AddIcon from '@mui/icons-material/Add';
// import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import SmilarProduct from '../SimilarProduct/SmilarProduct';
// import ZoomableImage from './ZoomableImage';
// import { useAppDispatch, useAppSelector } from '../../../../Redux Toolkit/Store';
// import { useNavigate, useParams } from 'react-router-dom';
// import { fetchProductById, getAllProducts } from '../../../../Redux Toolkit/Customer/ProductSlice';
// import { addItemToCart } from '../../../../Redux Toolkit/Customer/CartSlice';
// import ProductReviewCard from '../../Review/ProductReviewCard';
// import RatingCard from '../../Review/RatingCard';
// import { fetchReviewsByProductId } from '../../../../Redux Toolkit/Customer/ReviewSlice';

// // ------- helpers to compute rating count & average safely for multiple shapes -------
// const getRatingCount = (reviews: any[] = []) => {
//   return reviews.reduce((count, r) => {
//     if (Array.isArray(r?.ratings)) return count + r.ratings.length; // when each review has an array of ratings
//     if (typeof r?.rating === 'number') return count + 1;            // when each review has a single numeric rating
//     return count;
//   }, 0);
// };

// const getAverageRating = (reviews: any[] = []) => {
//   let sum = 0;
//   let n = 0;
//   for (const r of reviews) {
//     if (Array.isArray(r?.ratings)) {
//       for (const val of r.ratings) {
//         const v = typeof val === 'number' ? val : (val?.value ?? val?.rating ?? null);
//         if (typeof v === 'number') { sum += v; n++; }
//       }
//     } else if (typeof r?.rating === 'number') {
//       sum += r.rating; n++;
//     }
//   }
//   return n ? sum / n : 0;
// };

// const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: "auto",
//     height: "100%",
//     // bgcolor: 'background.paper',
//     boxShadow: 24,
//     outline: "none",
// };

// const ProductDetails = () => {
//     const [open, setOpen] = React.useState(false);
//     const handleOpen = () => setOpen(true);
//     const handleClose = () => setOpen(false);
//     const dispatch = useAppDispatch();
//     const { products, review } = useAppSelector(store => store)
//     const navigate = useNavigate()
//     const { productId,categoryId } = useParams()
//     const [selectedImage, setSelectedImage] = useState(0);
//     const [quantity, setQuantity] = useState(1)

//     // ---- derived rating stats ----
//     const ratingCount = React.useMemo(() => getRatingCount(review?.reviews || []), [review?.reviews]);
//     const avgRating = React.useMemo(() => getAverageRating(review?.reviews || []), [review?.reviews]);

//     // ---- simple logger helpers ----
//     const log = (...args: any[]) => console.log('[ProductDetails]', ...args);
//     const warn = (...args: any[]) => console.warn('[ProductDetails]', ...args);
//     const error = (...args: any[]) => console.error('[ProductDetails]', ...args);

//     // ⬇️ Snackbar for login prompt when user isn't logged in
//     const [snackOpen, setSnackOpen] = useState(false);
//     const [snackMessage, setSnackMessage] = useState<string>('Please log in to add items to your cart.');
//     const [snackSeverity, setSnackSeverity] = useState<'warning'|'error'|'success'>('warning');

//     const openSnack = (message: string, severity: 'warning'|'error'|'success' = 'warning') => {
//         setSnackMessage(message);
//         setSnackSeverity(severity);
//         setSnackOpen(true);
//     };

//     const handleSnackClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
//         log('Snackbar close requested', { reason });
//         if (reason === 'clickaway') return;
//         setSnackOpen(false);
//     };

//     useEffect(() => {
//         if (productId) {
//             log('Fetching product & reviews', { productId });
//             dispatch(fetchProductById(Number(productId)))
//             dispatch(fetchReviewsByProductId({ productId: Number(productId) }))
//         }
//         log('Fetching related products', { categoryId });
//         dispatch(getAllProducts({ category: categoryId }));

//         // ⬇️ Scroll to top whenever the product changes
//         window.scrollTo(0, 0);
//     }, [productId]) // (keeping dependencies the same per your request)

//     // Mount / unmount logger
//     useEffect(() => {
//         log('Component mounted', { productId, categoryId });
//         return () => log('Component unmounted');
//     }, [])

//     // Snackbar state logger
//     useEffect(() => {
//         log('snackOpen changed', snackOpen);
//     }, [snackOpen])

//     const getJwt = () => {
//         const raw = localStorage.getItem('jwt');
//         log('getJwt: raw from localStorage', raw, 'type:', typeof raw);
//         const cleaned = raw?.trim();
//         const jwt = cleaned && cleaned !== 'null' && cleaned !== 'undefined' && cleaned !== '' ? cleaned : null;
//         log('getJwt: computed jwt', jwt);
//         return jwt;
//     };

//     const handleAddCart = () => {
//         log('handleAddCart clicked');
//         const jwt = getJwt();
//         if (!jwt) {
//             warn('No JWT detected — opening Snackbar');
//             openSnack('Please log in to add items to your cart.', 'warning');
//             return;
//         }
//         const payload = { productId: Number(productId), size: 'FREE', quantity };
//         log('Dispatching addItemToCart', { jwtPresent: !!jwt, payload });
//         (dispatch as any)(addItemToCart({ jwt, request: payload }))
//             .unwrap()
//             .then((res: any) => {
//                 log('addItemToCart resolved', res);
//                 openSnack('Added to bag', 'success');
//             })
//             .catch((e: any) => {
//                 error('addItemToCart rejected', e);
//                 const status = e?.response?.status ?? e?.status;
//                 if (status === 401 || status === 403) {
//                     openSnack('Session expired. Please log in again.', 'warning');
//                 } else {
//                     openSnack('Failed to add item. Please try again.', 'error');
//                 }
//             });
//     };

//     const handleWishlist = () => {
//         log('handleWishlist clicked');
//         const jwt = getJwt();
//         if (!jwt) {
//             warn('No JWT detected — opening Snackbar (wishlist)');
//             openSnack('Please log in to add items to your wishlist.', 'warning');
//             return;
//         }
//         // TODO: Replace with real wishlist action
//         openSnack('Added to wishlist', 'success');
//     };

//     return (
//         <div className='px-5 lg:px-20 pt-10 '>
//             <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>

//                 <section className='flex flex-col lg:flex-row gap-5'>
//                     <div className='w-full lg:w-[15%] flex flex-wrap lg:flex-col gap-3'>
//                         {products.product?.images?.map((item: string, index: number) => (
//                             <img key={index} onClick={() => setSelectedImage(index)} className='lg:w-full w-[50px] cursor-pointer rounded-md' src={item} alt="" />
//                         ))}
//                     </div>
//                     <div className='w-full lg:w-[85%]'>
//                         {products.product?.images && (
//                             <img onClick={handleOpen} className='w-full rounded-md cursor-zoom-out' src={products.product?.images[selectedImage]} alt="" />
//                         )}
//                     </div>

//                     <Modal
//                         open={open}
//                         onClose={handleClose}
//                         aria-labelledby="modal-modal-title"
//                         aria-describedby="modal-modal-description"
//                     >
//                         <Box sx={style}>
//                             {products.product?.images && (
//                                 <ZoomableImage src={products.product?.images[selectedImage]} alt="" />
//                             )}
//                         </Box>
//                     </Modal>
//                 </section>

//                 <section>
//                     <h1 className='font-bold text-lg text-teal-950'>{products.product?.seller?.businessDetails.businessName}</h1>
//                     <p className='text-gray-500 font-semibold'>{products.product?.title}</p>

//                     {/* Rating summary */}
//                     <div className='flex justify-between items-center py-2 border w-[220px] px-3 mt-5'>
//                         <div className='flex flex-col items-center justify-center w-1/2'>
//                             <div className='flex gap-1 items-center justify-center'>
//                                 <span>{avgRating ? avgRating.toFixed(1) : '–'}</span>
//                                 <StarIcon sx={{ color: teal[600], fontSize: "17px" }} />
//                             </div>
//                         </div>
//                         <Divider orientation="vertical" flexItem />
//                         <div className='flex items-center justify-center w-1/2'>
//                             <span>{ratingCount} Ratings</span>
//                         </div>
//                     </div>

//                     <div className='space-y-2'>
//                         <div className='price flex items-center gap-3 mt-5 text-lg'>
//                             <span className='font-semibold text-gray-800' > ₹{products.product?.sellingPrice}</span>
//                             <span className='text thin-line-through text-gray-400 '>₹{products.product?.mrpPrice}</span>
//                             <span className='text-[#00927c] font-semibold'>{products.product?.discountPercent}% off</span>
//                         </div>
//                         <p className='text-sm'>Inclusive of all taxes. Free Shipping above ₹1499.</p>
//                     </div>
//                     <div className='mt-5'>
//                         <p >
//                             {products.product?.description}
//                         </p>
//                     </div>

//                     <div className='mt-7 space-y-3'>
//                         <div className='flex items-center gap-4'>
//                             <ShieldIcon sx={{ color: teal[400] }} />
//                             <p>Authentic & Quality Assured</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <WorkspacePremiumIcon sx={{ color: teal[400] }} />
//                             <p>100% money back guarantee</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <LocalShippingIcon sx={{ color: teal[400] }} />
//                             <p>Free Shipping & Returns (T&C Apply)</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <Wallet sx={{ color: teal[400] }} />
//                             <p>Pay on delivery might be available</p>
//                         </div>
//                     </div>

//                     <div className='mt-7 space-y-2'>
//                         <h1>QUANTITY:</h1>
//                         <div className=' flex items-center gap-2  w-[140px] justify-between'>
//                             <Button disabled={quantity == 1} onClick={() => setQuantity(quantity - 1)} variant='outlined'>
//                                 <RemoveIcon />
//                             </Button>
//                             <span className='px-3 text-lg font-semibold'>
//                                 {quantity}
//                             </span>
//                             <Button onClick={() => setQuantity(quantity + 1)} variant='outlined'>
//                                 <AddIcon />
//                             </Button>
//                         </div>
//                     </div>

//                     <div className="mt-12 flex items-center gap-5">
//                         <Button
//                             onClick={handleAddCart}
//                             sx={{ py: "1rem" }}
//                             variant='contained' fullWidth startIcon={<AddShoppingCartIcon />}>
//                             Add To Bag
//                         </Button>
//                         <Button
//                             sx={{ py: "1rem" }}
//                             variant='outlined' fullWidth startIcon={<FavoriteBorderIcon />} onClick={handleWishlist}>
//                             Whishlist
//                         </Button>
//                     </div>
//                     <div className="ratings w-full mt-10">
//                         <h1 className="font-semibold text-lg pb-4">
//                             Review & Ratings
//                         </h1>

//                         {/* Commenting now because raiting is not working. Need to fix later */}
//                         {/* <RatingCard totalReview={review.reviews.length} /> */}
//                         <div className='mt-10'>
//                             <div className="space-y-5">
//                                 {review.reviews.map((item: any, i: number) => (
//                                     <div key={i} className='space-y-5'>
//                                         <ProductReviewCard item={item} />
//                                         <Divider />
//                                     </div>
//                                 ))}
//                                 <Button onClick={() => navigate(`/reviews/${productId}`)}>View All {review.reviews.length} Reviews</Button>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             </div>

//             <section className='mt-20'>
//                 <h1 className='text-lg font-bold'>Similar Product</h1>

//                 <div className='pt-5'>
//                     <SmilarProduct />
//                 </div>
//             </section>

//             {/* Login prompt snackbar */}
//             <Snackbar
//                 open={snackOpen}
//                 autoHideDuration={3000}
//                 onClose={handleSnackClose}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//                 sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
//             >
//                 <Alert onClose={handleSnackClose} severity={snackSeverity} variant="filled" sx={{ width: '100%' }}>
//                     {snackMessage}
//                 </Alert>
//             </Snackbar>
//         </div>
//     )
// }

// export default ProductDetails

// import React, { useEffect, useState } from 'react'
// import StarIcon from '@mui/icons-material/Star';
// import { teal } from '@mui/material/colors';
// import { Box, Button, Divider, Grid, IconButton, LinearProgress, Modal, Rating, Snackbar, Alert, useMediaQuery, useTheme } from '@mui/material';
// import ShieldIcon from '@mui/icons-material/Shield';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import { Wallet } from '@mui/icons-material';
// import RemoveIcon from '@mui/icons-material/Remove';
// import AddIcon from '@mui/icons-material/Add';
// import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
// import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import SmilarProduct from '../SimilarProduct/SmilarProduct';
// import ZoomableImage from './ZoomableImage';
// import { useAppDispatch, useAppSelector } from '../../../../Redux Toolkit/Store';
// import { useNavigate, useParams } from 'react-router-dom';
// import { fetchProductById, getAllProducts } from '../../../../Redux Toolkit/Customer/ProductSlice';
// import { addItemToCart } from '../../../../Redux Toolkit/Customer/CartSlice';
// import ProductReviewCard from '../../Review/ProductReviewCard';
// import RatingCard from '../../Review/RatingCard';
// import { fetchReviewsByProductId } from '../../../../Redux Toolkit/Customer/ReviewSlice';

// // ------- helpers to compute rating count & average safely for multiple shapes -------
// const getRatingCount = (reviews: any[] = []) => {
//     return reviews.reduce((count, r) => {
//         if (Array.isArray(r?.ratings)) return count + r.ratings.length; // when each review has an array of ratings
//         if (typeof r?.rating === 'number') return count + 1;            // when each review has a single numeric rating
//         return count;
//     }, 0);
// };

// const getAverageRating = (reviews: any[] = []) => {
//     let sum = 0;
//     let n = 0;
//     for (const r of reviews) {
//         if (Array.isArray(r?.ratings)) {
//             for (const val of r.ratings) {
//                 const v = typeof val === 'number' ? val : (val?.value ?? val?.rating ?? null);
//                 if (typeof v === 'number') { sum += v; n++; }
//             }
//         } else if (typeof r?.rating === 'number') {
//             sum += r.rating; n++;
//         }
//     }
//     return n ? sum / n : 0;
// };

// const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: "auto",
//     height: "100%",
//     boxShadow: 24,
//     outline: "none",
//     backgroundColor: '#ffffff',
//     overflow: 'hidden',
// };

// const ProductDetails = () => {
//     const [open, setOpen] = React.useState(false);
//     const dispatch = useAppDispatch();
//     const { products, review } = useAppSelector(store => store)
//     const navigate = useNavigate()
//     const { productId,categoryId } = useParams()
//     const [selectedImage, setSelectedImage] = useState(0);
//     const [modalImageIndex, setModalImageIndex] = useState(0);
//     const [quantity, setQuantity] = useState(1)

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//     // ---- derived rating stats ----
//     const ratingCount = React.useMemo(() => getRatingCount(review?.reviews || []), [review?.reviews]);
//     const avgRating = React.useMemo(() => getAverageRating(review?.reviews || []), [review?.reviews]);

//     // ---- simple logger helpers ----
//     const log = (...args: any[]) => console.log('[ProductDetails]', ...args);
//     const warn = (...args: any[]) => console.warn('[ProductDetails]', ...args);
//     const error = (...args: any[]) => console.error('[ProductDetails]', ...args);

//     // ⬇️ Snackbar for login prompt when user isn't logged in
//     const [snackOpen, setSnackOpen] = useState(false);
//     const [snackMessage, setSnackMessage] = useState<string>('Please log in to add items to your cart.');
//     const [snackSeverity, setSnackSeverity] = useState<'warning'|'error'|'success'>('warning');

//     const openSnack = (message: string, severity: 'warning'|'error'|'success' = 'warning') => {
//         setSnackMessage(message);
//         setSnackSeverity(severity);
//         setSnackOpen(true);
//     };

//     const handleSnackClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
//         log('Snackbar close requested', { reason });
//         if (reason === 'clickaway') return;
//         setSnackOpen(false);
//     };

//     useEffect(() => {
//         if (productId) {
//             log('Fetching product & reviews', { productId });
//             dispatch(fetchProductById(Number(productId)))
//             dispatch(fetchReviewsByProductId({ productId: Number(productId) }))
//         }
//         log('Fetching related products', { categoryId });
//         dispatch(getAllProducts({ category: categoryId }));

//         // ⬇️ Scroll to top whenever the product changes
//         window.scrollTo(0, 0);
//     }, [productId]) // (keeping dependencies the same per your request)

//     // Mount / unmount logger
//     useEffect(() => {
//         log('Component mounted', { productId, categoryId });
//         return () => log('Component unmounted');
//     }, [])

//     // Snackbar state logger
//     useEffect(() => {
//         log('snackOpen changed', snackOpen);
//     }, [snackOpen])

//     const getJwt = () => {
//         const raw = localStorage.getItem('jwt');
//         log('getJwt: raw from localStorage', raw, 'type:', typeof raw);
//         const cleaned = raw?.trim();
//         const jwt = cleaned && cleaned !== 'null' && cleaned !== 'undefined' && cleaned !== '' ? cleaned : null;
//         log('getJwt: computed jwt', jwt);
//         return jwt;
//     };

//     const handleAddCart = () => {
//         log('handleAddCart clicked');
//         const jwt = getJwt();
//         if (!jwt) {
//             warn('No JWT detected — opening Snackbar');
//             openSnack('Please log in to add items to your cart.', 'warning');
//             return;
//         }
//         const payload = { productId: Number(productId), size: 'FREE', quantity };
//         log('Dispatching addItemToCart', { jwtPresent: !!jwt, payload });
//         (dispatch as any)(addItemToCart({ jwt, request: payload }))
//             .unwrap()
//             .then((res: any) => {
//                 log('addItemToCart resolved', res);
//                 openSnack('Added to bag', 'success');
//             })
//             .catch((e: any) => {
//                 error('addItemToCart rejected', e);
//                 const status = e?.response?.status ?? e?.status;
//                 if (status === 401 || status === 403) {
//                     openSnack('Session expired. Please log in again.', 'warning');
//                 } else {
//                     openSnack('Failed to add item. Please try again.', 'error');
//                 }
//             });
//     };

//     const handleWishlist = () => {
//         log('handleWishlist clicked');
//         const jwt = getJwt();
//         if (!jwt) {
//             warn('No JWT detected — opening Snackbar (wishlist)');
//             openSnack('Please log in to add items to your wishlist.', 'warning');
//             return;
//         }
//         // TODO: Replace with real wishlist action
//         openSnack('Added to wishlist', 'success');
//     };

//     const images = products.product?.images || [];

//     const handleOpen = () => {
//         setModalImageIndex(selectedImage);
//         setOpen(true);
//     };

//     const handleClose = () => setOpen(false);

//     const handlePrevImage = () => {
//         if (!images.length) return;
//         setModalImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//     };

//     const handleNextImage = () => {
//         if (!images.length) return;
//         setModalImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//     };

//     return (
//         <div className='px-5 lg:px-20 pt-10 '>
//             <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>

//                 <section className='flex flex-col lg:flex-row gap-5'>
//                     <div className='w-full lg:w-[15%] flex flex-wrap lg:flex-col gap-3'>
//                         {products.product?.images?.map((item: string, index: number) => (
//                             <img
//                                 key={index}
//                                 onClick={() => setSelectedImage(index)}
//                                 className='lg:w-full w-[50px] cursor-pointer rounded-md'
//                                 src={item}
//                                 alt=""
//                             />
//                         ))}
//                     </div>
//                     <div className='w-full lg:w-[85%]'>
//                         {products.product?.images && (
//                             <img
//                                 onClick={handleOpen}
//                                 className='w-full rounded-md cursor-zoom-out'
//                                 src={products.product?.images[selectedImage]}
//                                 alt=""
//                             />
//                         )}
//                     </div>

//                     <Modal
//                         open={open}
//                         onClose={handleClose}
//                         aria-labelledby="modal-modal-title"
//                         aria-describedby="modal-modal-description"
//                         slotProps={{
//                             backdrop: {
//                                 sx: {
//                                     backgroundColor: isSmallScreen ? 'rgba(0, 0, 0, 0.92)' : 'rgba(0, 0, 0, 0.72)',
//                                 },
//                             },
//                         }}
//                     >
//                         {isSmallScreen ? (
//                             <Box
//                                 sx={{
//                                     position: 'fixed',
//                                     inset: 0,
//                                     width: '100vw',
//                                     height: '100vh',
//                                     backgroundColor: '#000',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     overflow: 'hidden',
//                                 }}
//                             >
//                                 <IconButton
//                                     onClick={handleClose}
//                                     sx={{
//                                         position: 'absolute',
//                                         top: 12,
//                                         right: 12,
//                                         zIndex: 5,
//                                         color: '#fff',
//                                         backgroundColor: 'rgba(255,255,255,0.12)',
//                                         '&:hover': {
//                                             backgroundColor: 'rgba(255,255,255,0.2)',
//                                         },
//                                     }}
//                                 >
//                                     <CloseRoundedIcon />
//                                 </IconButton>

//                                 {images.length > 1 && (
//                                     <IconButton
//                                         onClick={handlePrevImage}
//                                         sx={{
//                                             position: 'absolute',
//                                             left: 10,
//                                             top: '50%',
//                                             transform: 'translateY(-50%)',
//                                             zIndex: 5,
//                                             color: '#fff',
//                                             backgroundColor: 'rgba(255,255,255,0.12)',
//                                             '&:hover': {
//                                                 backgroundColor: 'rgba(255,255,255,0.2)',
//                                             },
//                                         }}
//                                     >
//                                         <ChevronLeftRoundedIcon />
//                                     </IconButton>
//                                 )}

//                                 <div className='w-full h-full flex items-center justify-center px-10'>
//                                     {images.length > 0 && (
//                                         <img
//                                             src={images[modalImageIndex]}
//                                             alt=""
//                                             className='max-w-full max-h-full object-contain'
//                                         />
//                                     )}
//                                 </div>

//                                 {images.length > 1 && (
//                                     <IconButton
//                                         onClick={handleNextImage}
//                                         sx={{
//                                             position: 'absolute',
//                                             right: 10,
//                                             top: '50%',
//                                             transform: 'translateY(-50%)',
//                                             zIndex: 5,
//                                             color: '#fff',
//                                             backgroundColor: 'rgba(255,255,255,0.12)',
//                                             '&:hover': {
//                                                 backgroundColor: 'rgba(255,255,255,0.2)',
//                                             },
//                                         }}
//                                     >
//                                         <ChevronRightRoundedIcon />
//                                     </IconButton>
//                                 )}
//                             </Box>
//                         ) : (
//                             <Box sx={style}>
//                                 <div className='w-full h-full flex items-center justify-center px-4 bg-white'>
//                                     {images.length > 0 && (
//                                         <ZoomableImage src={images[modalImageIndex]} alt="" />
//                                     )}
//                                 </div>
//                             </Box>
//                         )}
//                     </Modal>
//                 </section>

//                 <section>
//                     <h1 className='font-bold text-lg text-teal-950'>{products.product?.seller?.businessDetails.businessName}</h1>
//                     <p className='text-gray-500 font-semibold'>{products.product?.title}</p>

//                     {/* Rating summary */}
//                     <div className='flex justify-between items-center py-2 border w-[220px] px-3 mt-5'>
//                         <div className='flex flex-col items-center justify-center w-1/2'>
//                             <div className='flex gap-1 items-center justify-center'>
//                                 <span>{avgRating ? avgRating.toFixed(1) : '–'}</span>
//                                 <StarIcon sx={{ color: teal[600], fontSize: "17px" }} />
//                             </div>
//                         </div>
//                         <Divider orientation="vertical" flexItem />
//                         <div className='flex items-center justify-center w-1/2'>
//                             <span>{ratingCount} Ratings</span>
//                         </div>
//                     </div>

//                     <div className='space-y-2'>
//                         <div className='price flex items-center gap-3 mt-5 text-lg'>
//                             <span className='font-semibold text-gray-800' > ₹{products.product?.sellingPrice}</span>
//                             <span className='text thin-line-through text-gray-400 '>₹{products.product?.mrpPrice}</span>
//                             <span className='text-[#00927c] font-semibold'>{products.product?.discountPercent}% off</span>
//                         </div>
//                         <p className='text-sm'>Inclusive of all taxes. Free Shipping above ₹1499.</p>
//                     </div>
//                     <div className='mt-5'>
//                         <p >
//                             {products.product?.description}
//                         </p>
//                     </div>

//                     <div className='mt-7 space-y-3'>
//                         <div className='flex items-center gap-4'>
//                             <ShieldIcon sx={{ color: teal[400] }} />
//                             <p>Authentic & Quality Assured</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <WorkspacePremiumIcon sx={{ color: teal[400] }} />
//                             <p>100% money back guarantee</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <LocalShippingIcon sx={{ color: teal[400] }} />
//                             <p>Free Shipping & Returns (T&C Apply)</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <Wallet sx={{ color: teal[400] }} />
//                             <p>Pay on delivery might be available</p>
//                         </div>
//                     </div>

//                     <div className='mt-7 space-y-2'>
//                         <h1>QUANTITY:</h1>
//                         <div className=' flex items-center gap-2  w-[140px] justify-between'>
//                             <Button disabled={quantity == 1} onClick={() => setQuantity(quantity - 1)} variant='outlined'>
//                                 <RemoveIcon />
//                             </Button>
//                             <span className='px-3 text-lg font-semibold'>
//                                 {quantity}
//                             </span>
//                             <Button onClick={() => setQuantity(quantity + 1)} variant='outlined'>
//                                 <AddIcon />
//                             </Button>
//                         </div>
//                     </div>

//                     <div className="mt-12 flex items-center gap-5">
//                         <Button
//                             onClick={handleAddCart}
//                             sx={{ py: "1rem" }}
//                             variant='contained' fullWidth startIcon={<AddShoppingCartIcon />}>
//                             Add To Bag
//                         </Button>
//                         <Button
//                             sx={{ py: "1rem" }}
//                             variant='outlined' fullWidth startIcon={<FavoriteBorderIcon />} onClick={handleWishlist}>
//                             Whishlist
//                         </Button>
//                     </div>
//                     <div className="ratings w-full mt-10">
//                         <h1 className="font-semibold text-lg pb-4">
//                             Review & Ratings
//                         </h1>

//                         {/* Commenting now because raiting is not working. Need to fix later */}
//                         {/* <RatingCard totalReview={review.reviews.length} /> */}
//                         <div className='mt-10'>
//                             <div className="space-y-5">
//                                 {review.reviews.map((item: any, i: number) => (
//                                     <div key={i} className='space-y-5'>
//                                         <ProductReviewCard item={item} />
//                                         <Divider />
//                                     </div>
//                                 ))}
//                                 <Button onClick={() => navigate(`/reviews/${productId}`)}>View All {review.reviews.length} Reviews</Button>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             </div>

//             <section className='mt-20'>
//                 <h1 className='text-lg font-bold'>Similar Product</h1>

//                 <div className='pt-5'>
//                     <SmilarProduct />
//                 </div>
//             </section>

//             {/* Login prompt snackbar */}
//             <Snackbar
//                 open={snackOpen}
//                 autoHideDuration={3000}
//                 onClose={handleSnackClose}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//                 sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
//             >
//                 <Alert onClose={handleSnackClose} severity={snackSeverity} variant="filled" sx={{ width: '100%' }}>
//                     {snackMessage}
//                 </Alert>
//             </Snackbar>
//         </div>
//     )
// }

// export default ProductDetails




// import React, { useEffect, useState } from 'react'
// import StarIcon from '@mui/icons-material/Star';
// import { teal } from '@mui/material/colors';
// import { Box, Button, Divider, Grid, IconButton, LinearProgress, Modal, Rating, Snackbar, Alert, useMediaQuery, useTheme } from '@mui/material';
// import ShieldIcon from '@mui/icons-material/Shield';
// import LocalShippingIcon from '@mui/icons-material/LocalShipping';
// import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import { Wallet } from '@mui/icons-material';
// import RemoveIcon from '@mui/icons-material/Remove';
// import AddIcon from '@mui/icons-material/Add';
// import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
// import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
// import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
// import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
// import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
// import SmilarProduct from '../SimilarProduct/SmilarProduct';
// import ZoomableImage from './ZoomableImage';
// import { useAppDispatch, useAppSelector } from '../../../../Redux Toolkit/Store';
// import { useNavigate, useParams } from 'react-router-dom';
// import { fetchProductById, getAllProducts } from '../../../../Redux Toolkit/Customer/ProductSlice';
// import { addItemToCart } from '../../../../Redux Toolkit/Customer/CartSlice';
// import ProductReviewCard from '../../Review/ProductReviewCard';
// import RatingCard from '../../Review/RatingCard';
// import { fetchReviewsByProductId } from '../../../../Redux Toolkit/Customer/ReviewSlice';
// import { trackEvent } from '../../../../util/analytics';

// // ------- helpers to compute rating count & average safely for multiple shapes -------
// const getRatingCount = (reviews: any[] = []) => {
//     return reviews.reduce((count, r) => {
//         if (Array.isArray(r?.ratings)) return count + r.ratings.length;
//         if (typeof r?.rating === 'number') return count + 1;
//         return count;
//     }, 0);
// };

// const getAverageRating = (reviews: any[] = []) => {
//     let sum = 0;
//     let n = 0;
//     for (const r of reviews) {
//         if (Array.isArray(r?.ratings)) {
//             for (const val of r.ratings) {
//                 const v = typeof val === 'number' ? val : (val?.value ?? val?.rating ?? null);
//                 if (typeof v === 'number') { sum += v; n++; }
//             }
//         } else if (typeof r?.rating === 'number') {
//             sum += r.rating; n++;
//         }
//     }
//     return n ? sum / n : 0;
// };

// const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: "auto",
//     height: "100%",
//     boxShadow: 24,
//     outline: "none",
//     backgroundColor: '#ffffff',
//     overflow: 'hidden',
// };

// const ProductDetails = () => {
//     const [open, setOpen] = React.useState(false);
//     const dispatch = useAppDispatch();
//     const { products, review } = useAppSelector(store => store)
//     const navigate = useNavigate()
//     const { productId, categoryId } = useParams()
//     const [selectedImage, setSelectedImage] = useState(0);
//     const [modalImageIndex, setModalImageIndex] = useState(0);
//     const [quantity, setQuantity] = useState(1)

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

//     // ---- derived rating stats ----
//     const ratingCount = React.useMemo(() => getRatingCount(review?.reviews || []), [review?.reviews]);
//     const avgRating = React.useMemo(() => getAverageRating(review?.reviews || []), [review?.reviews]);

//     // ---- simple logger helpers ----
//     const log = (...args: any[]) => console.log('[ProductDetails]', ...args);
//     const warn = (...args: any[]) => console.warn('[ProductDetails]', ...args);
//     const error = (...args: any[]) => console.error('[ProductDetails]', ...args);

//     // ⬇️ Snackbar for login prompt when user isn't logged in
//     const [snackOpen, setSnackOpen] = useState(false);
//     const [snackMessage, setSnackMessage] = useState<string>('Please log in to add items to your cart.');
//     const [snackSeverity, setSnackSeverity] = useState<'warning' | 'error' | 'success'>('warning');

//     const openSnack = (message: string, severity: 'warning' | 'error' | 'success' = 'warning') => {
//         setSnackMessage(message);
//         setSnackSeverity(severity);
//         setSnackOpen(true);
//     };

//     const handleSnackClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
//         log('Snackbar close requested', { reason });
//         if (reason === 'clickaway') return;
//         setSnackOpen(false);
//     };

//     useEffect(() => {
//         if (productId) {
//             log('Fetching product & reviews', { productId });

//             dispatch(fetchProductById(Number(productId)))
//             dispatch(fetchReviewsByProductId({ productId: Number(productId) }))

//             // trackEvent('PRODUCT_VIEW', {
//             //     productId: Number(productId),
//             // });

//             try {
//                 trackEvent('PRODUCT_DETAIL_VIEW', {
//                     productId: Number(productId),
//                     page: window.location.pathname,
//                     metadata: JSON.stringify({
//                         categoryId,
//                     }),
//                 });
//             } catch (err) {
//                 console.log('PRODUCT_DETAIL_VIEW tracking failed:', err);
//             }
//         }

//         log('Fetching related products', { categoryId });
//         dispatch(getAllProducts({ category: categoryId }));

//         // ⬇️ Scroll to top whenever the product changes
//         window.scrollTo(0, 0);
//     }, [productId]) // (keeping dependencies the same per your request)

//     // Mount / unmount logger
//     useEffect(() => {
//         log('Component mounted', { productId, categoryId });
//         return () => log('Component unmounted');
//     }, [])

//     // Snackbar state logger
//     useEffect(() => {
//         log('snackOpen changed', snackOpen);
//     }, [snackOpen])

//     const getJwt = () => {
//         const raw = localStorage.getItem('jwt');
//         log('getJwt: raw from localStorage', raw, 'type:', typeof raw);
//         const cleaned = raw?.trim();
//         const jwt = cleaned && cleaned !== 'null' && cleaned !== 'undefined' && cleaned !== '' ? cleaned : null;
//         log('getJwt: computed jwt', jwt);
//         return jwt;
//     };

//     const handleAddCart = () => {
//         log('handleAddCart clicked');
//         const jwt = getJwt();
//         if (!jwt) {
//             warn('No JWT detected — opening Snackbar');
//             openSnack('Please log in to add items to your cart.', 'warning');
//             return;
//         }
//         const payload = { productId: Number(productId), size: 'FREE', quantity };
//         log('Dispatching addItemToCart', { jwtPresent: !!jwt, payload });
//         (dispatch as any)(addItemToCart({ jwt, request: payload }))
//             .unwrap()
//             .then((res: any) => {
//                 log('addItemToCart resolved', res);

//                 try {
//                     trackEvent('ADD_TO_CART', {
//                         productId: Number(productId),
//                         page: window.location.pathname,
//                         metadata: JSON.stringify({
//                             categoryId,
//                             size: 'FREE',
//                             quantity,
//                         }),
//                     });
//                 } catch (err) {
//                     console.log('ADD_TO_CART tracking failed:', err);
//                 }

//                 openSnack('Added to bag', 'success');
//             })
//             .catch((e: any) => {
//                 error('addItemToCart rejected', e);
//                 const status = e?.response?.status ?? e?.status;
//                 if (status === 401 || status === 403) {
//                     openSnack('Session expired. Please log in again.', 'warning');
//                 } else {
//                     openSnack('Failed to add item. Please try again.', 'error');
//                 }
//             });
//     };

//     const handleWishlist = () => {
//         log('handleWishlist clicked');
//         const jwt = getJwt();
//         if (!jwt) {
//             warn('No JWT detected — opening Snackbar (wishlist)');
//             openSnack('Please log in to add items to your wishlist.', 'warning');
//             return;
//         }
//         // TODO: Replace with real wishlist action
//         openSnack('Added to wishlist', 'success');
//     };

//     const images = products.product?.images || [];

//     const handleOpen = () => {
//         setModalImageIndex(selectedImage);
//         setOpen(true);
//     };

//     const handleClose = () => setOpen(false);

//     const handlePrevImage = () => {
//         if (!images.length) return;
//         setModalImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
//     };

//     const handleNextImage = () => {
//         if (!images.length) return;
//         setModalImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
//     };

//     return (
//         <div className='px-5 lg:px-20 pt-10 '>
//             <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>

//                 <section className='flex flex-col lg:flex-row gap-5'>
//                     <div className='w-full lg:w-[15%] flex flex-wrap lg:flex-col gap-3'>
//                         {products.product?.images?.map((item: string, index: number) => (
//                             <img
//                                 key={index}
//                                 onClick={() => setSelectedImage(index)}
//                                 className='lg:w-full w-[50px] cursor-pointer rounded-md'
//                                 src={item}
//                                 alt=""
//                             />
//                         ))}
//                     </div>
//                     <div className='w-full lg:w-[85%]'>
//                         {products.product?.images && (
//                             <img
//                                 onClick={handleOpen}
//                                 className='w-full rounded-md cursor-zoom-out'
//                                 src={products.product?.images[selectedImage]}
//                                 alt=""
//                             />
//                         )}
//                     </div>

//                     <Modal
//                         open={open}
//                         onClose={handleClose}
//                         aria-labelledby="modal-modal-title"
//                         aria-describedby="modal-modal-description"
//                         slotProps={{
//                             backdrop: {
//                                 sx: {
//                                     backgroundColor: isSmallScreen ? 'rgba(0, 0, 0, 0.92)' : 'rgba(0, 0, 0, 0.72)',
//                                 },
//                             },
//                         }}
//                     >
//                         {isSmallScreen ? (
//                             <Box
//                                 sx={{
//                                     position: 'fixed',
//                                     inset: 0,
//                                     width: '100vw',
//                                     height: '100vh',
//                                     backgroundColor: '#000',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     overflow: 'hidden',
//                                 }}
//                             >
//                                 <IconButton
//                                     onClick={handleClose}
//                                     sx={{
//                                         position: 'absolute',
//                                         top: 12,
//                                         right: 12,
//                                         zIndex: 5,
//                                         color: '#fff',
//                                         backgroundColor: 'rgba(255,255,255,0.12)',
//                                         '&:hover': {
//                                             backgroundColor: 'rgba(255,255,255,0.2)',
//                                         },
//                                     }}
//                                 >
//                                     <CloseRoundedIcon />
//                                 </IconButton>

//                                 {images.length > 1 && (
//                                     <IconButton
//                                         onClick={handlePrevImage}
//                                         sx={{
//                                             position: 'absolute',
//                                             left: 10,
//                                             top: '50%',
//                                             transform: 'translateY(-50%)',
//                                             zIndex: 5,
//                                             color: '#fff',
//                                             backgroundColor: 'rgba(255,255,255,0.12)',
//                                             '&:hover': {
//                                                 backgroundColor: 'rgba(255,255,255,0.2)',
//                                             },
//                                         }}
//                                     >
//                                         <ChevronLeftRoundedIcon />
//                                     </IconButton>
//                                 )}

//                                 <div className='w-full h-full flex items-center justify-center px-10'>
//                                     {images.length > 0 && (
//                                         <img
//                                             src={images[modalImageIndex]}
//                                             alt=""
//                                             className='max-w-full max-h-full object-contain'
//                                         />
//                                     )}
//                                 </div>

//                                 {images.length > 1 && (
//                                     <IconButton
//                                         onClick={handleNextImage}
//                                         sx={{
//                                             position: 'absolute',
//                                             right: 10,
//                                             top: '50%',
//                                             transform: 'translateY(-50%)',
//                                             zIndex: 5,
//                                             color: '#fff',
//                                             backgroundColor: 'rgba(255,255,255,0.12)',
//                                             '&:hover': {
//                                                 backgroundColor: 'rgba(255,255,255,0.2)',
//                                             },
//                                         }}
//                                     >
//                                         <ChevronRightRoundedIcon />
//                                     </IconButton>
//                                 )}
//                             </Box>
//                         ) : (
//                             <Box sx={style}>
//                                 <div className='w-full h-full flex items-center justify-center px-4 bg-white'>
//                                     {images.length > 0 && (
//                                         <ZoomableImage src={images[modalImageIndex]} alt="" />
//                                     )}
//                                 </div>
//                             </Box>
//                         )}
//                     </Modal>
//                 </section>

//                 <section>
//                     <h1 className='font-bold text-lg text-teal-950'>{products.product?.seller?.businessDetails.businessName}</h1>
//                     <p className='text-gray-500 font-semibold'>{products.product?.title}</p>

//                     {/* Rating summary */}
//                     <div className='flex justify-between items-center py-2 border w-[220px] px-3 mt-5'>
//                         <div className='flex flex-col items-center justify-center w-1/2'>
//                             <div className='flex gap-1 items-center justify-center'>
//                                 <span>{avgRating ? avgRating.toFixed(1) : '–'}</span>
//                                 <StarIcon sx={{ color: teal[600], fontSize: "17px" }} />
//                             </div>
//                         </div>
//                         <Divider orientation="vertical" flexItem />
//                         <div className='flex items-center justify-center w-1/2'>
//                             <span>{ratingCount} Ratings</span>
//                         </div>
//                     </div>

//                     <div className='space-y-2'>
//                         <div className='price flex items-center gap-3 mt-5 text-lg'>
//                             <span className='font-semibold text-gray-800' > ₹{products.product?.sellingPrice}</span>
//                             <span className='text thin-line-through text-gray-400 '>₹{products.product?.mrpPrice}</span>
//                             <span className='text-[#00927c] font-semibold'>{products.product?.discountPercent}% off</span>
//                         </div>
//                         <p className='text-sm'>Inclusive of all taxes. Free Shipping above ₹1499.</p>
//                     </div>
//                     <div className='mt-5'>
//                         <p>
//                             {products.product?.description}
//                         </p>
//                     </div>

//                     <div className='mt-7 space-y-3'>
//                         <div className='flex items-center gap-4'>
//                             <ShieldIcon sx={{ color: teal[400] }} />
//                             <p>Authentic & Quality Assured</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <WorkspacePremiumIcon sx={{ color: teal[400] }} />
//                             <p>100% money back guarantee</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <LocalShippingIcon sx={{ color: teal[400] }} />
//                             <p>Free Shipping & Returns (T&C Apply)</p>
//                         </div>

//                         <div className='flex items-center gap-4'>
//                             <Wallet sx={{ color: teal[400] }} />
//                             <p>Pay on delivery might be available</p>
//                         </div>
//                     </div>

//                     <div className='mt-7 space-y-2'>
//                         <h1>QUANTITY:</h1>
//                         <div className=' flex items-center gap-2  w-[140px] justify-between'>
//                             <Button disabled={quantity == 1} onClick={() => setQuantity(quantity - 1)} variant='outlined'>
//                                 <RemoveIcon />
//                             </Button>
//                             <span className='px-3 text-lg font-semibold'>
//                                 {quantity}
//                             </span>
//                             <Button onClick={() => setQuantity(quantity + 1)} variant='outlined'>
//                                 <AddIcon />
//                             </Button>
//                         </div>
//                     </div>

//                     <div className="mt-12 flex items-center gap-5">
//                         <Button
//                             onClick={handleAddCart}
//                             sx={{ py: "1rem" }}
//                             variant='contained' fullWidth startIcon={<AddShoppingCartIcon />}>
//                             Add To Bag
//                         </Button>
//                         <Button
//                             sx={{ py: "1rem" }}
//                             variant='outlined' fullWidth startIcon={<FavoriteBorderIcon />} onClick={handleWishlist}>
//                             Whishlist
//                         </Button>
//                     </div>
//                     <div className="ratings w-full mt-10">
//                         <h1 className="font-semibold text-lg pb-4">
//                             Review & Ratings
//                         </h1>

//                         {/* Commenting now because raiting is not working. Need to fix later */}
//                         {/* <RatingCard totalReview={review.reviews.length} /> */}
//                         <div className='mt-10'>
//                             <div className="space-y-5">
//                                 {review.reviews.map((item: any, i: number) => (
//                                     <div key={i} className='space-y-5'>
//                                         <ProductReviewCard item={item} />
//                                         <Divider />
//                                     </div>
//                                 ))}
//                                 <Button onClick={() => navigate(`/reviews/${productId}`)}>View All {review.reviews.length} Reviews</Button>
//                             </div>
//                         </div>
//                     </div>
//                 </section>
//             </div>

//             <section className='mt-20'>
//                 <h1 className='text-lg font-bold'>Similar Product</h1>

//                 <div className='pt-5'>
//                     <SmilarProduct />
//                 </div>
//             </section>

//             {/* Login prompt snackbar */}
//             <Snackbar
//                 open={snackOpen}
//                 autoHideDuration={3000}
//                 onClose={handleSnackClose}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//                 sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
//             >
//                 <Alert onClose={handleSnackClose} severity={snackSeverity} variant="filled" sx={{ width: '100%' }}>
//                     {snackMessage}
//                 </Alert>
//             </Snackbar>
//         </div>
//     )
// }

// export default ProductDetails




import React, { useEffect, useState } from 'react'
import StarIcon from '@mui/icons-material/Star';
import { teal } from '@mui/material/colors';
import { Box, Button, Divider, IconButton, Modal, Snackbar, Alert, useMediaQuery, useTheme } from '@mui/material';
import ShieldIcon from '@mui/icons-material/Shield';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { Wallet } from '@mui/icons-material';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import SmilarProduct from '../SimilarProduct/SmilarProduct';
import ZoomableImage from './ZoomableImage';
import { useAppDispatch, useAppSelector } from '../../../../Redux Toolkit/Store';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchProductById, getAllProducts } from '../../../../Redux Toolkit/Customer/ProductSlice';
import { addItemToCart } from '../../../../Redux Toolkit/Customer/CartSlice';
import ProductReviewCard from '../../Review/ProductReviewCard';
import { fetchReviewsByProductId } from '../../../../Redux Toolkit/Customer/ReviewSlice';
import {
    addProductToWishlist,
    getWishlistByUserId,
} from '../../../../Redux Toolkit/Customer/WishlistSlice';
import { trackEvent } from '../../../../util/analytics';

const getRatingCount = (reviews: any[] = []) => {
    return reviews.reduce((count, r) => {
        if (Array.isArray(r?.ratings)) return count + r.ratings.length;
        if (typeof r?.rating === 'number') return count + 1;
        return count;
    }, 0);
};

const getAverageRating = (reviews: any[] = []) => {
    let sum = 0;
    let n = 0;
    for (const r of reviews) {
        if (Array.isArray(r?.ratings)) {
            for (const val of r.ratings) {
                const v = typeof val === 'number' ? val : (val?.value ?? val?.rating ?? null);
                if (typeof v === 'number') { sum += v; n++; }
            }
        } else if (typeof r?.rating === 'number') {
            sum += r.rating; n++;
        }
    }
    return n ? sum / n : 0;
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "auto",
    height: "100%",
    boxShadow: 24,
    outline: "none",
    backgroundColor: '#ffffff',
    overflow: 'hidden',
};

const ProductDetails = () => {
    const [open, setOpen] = React.useState(false);
    const dispatch = useAppDispatch();
    const { products, review } = useAppSelector(store => store)
    const navigate = useNavigate()
    const { productId, categoryId } = useParams()
    const [selectedImage, setSelectedImage] = useState(0);
    const [modalImageIndex, setModalImageIndex] = useState(0);
    const [quantity, setQuantity] = useState(1)

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const ratingCount = React.useMemo(() => getRatingCount(review?.reviews || []), [review?.reviews]);
    const avgRating = React.useMemo(() => getAverageRating(review?.reviews || []), [review?.reviews]);

    const log = (...args: any[]) => console.log('[ProductDetails]', ...args);
    const warn = (...args: any[]) => console.warn('[ProductDetails]', ...args);
    const error = (...args: any[]) => console.error('[ProductDetails]', ...args);

    const [snackOpen, setSnackOpen] = useState(false);
    const [snackMessage, setSnackMessage] = useState<string>('Please log in to add items to your cart.');
    const [snackSeverity, setSnackSeverity] = useState<'warning' | 'error' | 'success'>('warning');

    const openSnack = (message: string, severity: 'warning' | 'error' | 'success' = 'warning') => {
        setSnackMessage(message);
        setSnackSeverity(severity);
        setSnackOpen(true);
    };

    const handleSnackClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        log('Snackbar close requested', { reason });
        if (reason === 'clickaway') return;
        setSnackOpen(false);
    };

    useEffect(() => {
        if (productId) {
            log('Fetching product & reviews', { productId });

            dispatch(fetchProductById(Number(productId)))
            dispatch(fetchReviewsByProductId({ productId: Number(productId) }))

            try {
                trackEvent('PRODUCT_DETAIL_VIEW', {
                    productId: Number(productId),
                    page: window.location.pathname,
                    metadata: JSON.stringify({
                        categoryId,
                    }),
                });
            } catch (err) {
                console.log('PRODUCT_DETAIL_VIEW tracking failed:', err);
            }
        }

        log('Fetching related products', { categoryId });
        dispatch(getAllProducts({ category: categoryId }));

        window.scrollTo(0, 0);
    }, [productId])

    useEffect(() => {
        log('Component mounted', { productId, categoryId });
        return () => log('Component unmounted');
    }, [])

    useEffect(() => {
        log('snackOpen changed', snackOpen);
    }, [snackOpen])

    const getJwt = () => {
        const raw = localStorage.getItem('jwt');
        log('getJwt: raw from localStorage', raw, 'type:', typeof raw);
        const cleaned = raw?.trim();
        const jwt = cleaned && cleaned !== 'null' && cleaned !== 'undefined' && cleaned !== '' ? cleaned : null;
        log('getJwt: computed jwt', jwt);
        return jwt;
    };

    const handleAddCart = () => {
        log('handleAddCart clicked');
        const jwt = getJwt();
        if (!jwt) {
            warn('No JWT detected — opening Snackbar');
            openSnack('Please log in to add items to your cart.', 'warning');
            return;
        }
        const payload = { productId: Number(productId), size: 'FREE', quantity };
        log('Dispatching addItemToCart', { jwtPresent: !!jwt, payload });
        (dispatch as any)(addItemToCart({ jwt, request: payload }))
            .unwrap()
            .then((res: any) => {
                log('addItemToCart resolved', res);

                try {
                    trackEvent('ADD_TO_CART', {
                        productId: Number(productId),
                        page: window.location.pathname,
                        metadata: JSON.stringify({
                            categoryId,
                            size: 'FREE',
                            quantity,
                        }),
                    });
                } catch (err) {
                    console.log('ADD_TO_CART tracking failed:', err);
                }

                openSnack('Added to bag', 'success');
            })
            .catch((e: any) => {
                error('addItemToCart rejected', e);
                const status = e?.response?.status ?? e?.status;
                if (status === 401 || status === 403) {
                    openSnack('Session expired. Please log in again.', 'warning');
                } else {
                    openSnack('Failed to add item. Please try again.', 'error');
                }
            });
    };

    const handleWishlist = () => {
        log('handleWishlist clicked');

        const jwt = getJwt();

        if (!jwt) {
            warn('No JWT detected — opening Snackbar (wishlist)');
            openSnack('Please log in to add items to your wishlist.', 'warning');
            return;
        }

        const selectedProductId = Number(productId);

        if (!selectedProductId || Number.isNaN(selectedProductId)) {
            openSnack('Invalid product. Please try again.', 'error');
            return;
        }

        dispatch(addProductToWishlist({ productId: selectedProductId }))
            .unwrap()
            .then(() => {
                dispatch(getWishlistByUserId());
                openSnack('Added to wishlist', 'success');
            })
            .catch((e: any) => {
                error('addProductToWishlist rejected', e);

                const status = e?.response?.status ?? e?.status;

                if (status === 401 || status === 403) {
                    openSnack('Session expired. Please log in again.', 'warning');
                } else {
                    openSnack(
                        e || 'Failed to update wishlist. Please try again.',
                        'error'
                    );
                }
            });
    };

    const images = products.product?.images || [];

    const handleOpen = () => {
        setModalImageIndex(selectedImage);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handlePrevImage = () => {
        if (!images.length) return;
        setModalImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    };

    const handleNextImage = () => {
        if (!images.length) return;
        setModalImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    };

    return (
        <div className='px-5 lg:px-20 pt-10 '>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-10'>

                <section className='flex flex-col lg:flex-row gap-5'>
                    <div className='w-full lg:w-[15%] flex flex-wrap lg:flex-col gap-3'>
                        {products.product?.images?.map((item: string, index: number) => (
                            <img
                                key={index}
                                onClick={() => setSelectedImage(index)}
                                className='lg:w-full w-[50px] cursor-pointer rounded-md'
                                src={item}
                                alt=""
                            />
                        ))}
                    </div>

                    <div className='w-full lg:w-[85%]'>
                        {products.product?.images && (
                            <img
                                onClick={handleOpen}
                                className='w-full rounded-md cursor-zoom-out'
                                src={products.product?.images[selectedImage]}
                                alt=""
                            />
                        )}
                    </div>

                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        slotProps={{
                            backdrop: {
                                sx: {
                                    backgroundColor: isSmallScreen
                                        ? 'rgba(0, 0, 0, 0.92)'
                                        : 'rgba(0, 0, 0, 0.72)',
                                },
                            },
                        }}
                    >
                        <>
                            {/* CLOSE BUTTON */}
                            <IconButton
                                onClick={handleClose}
                                sx={{
                                    position: 'fixed',
                                    top: isSmallScreen ? 105 : 100,
                                    right: isSmallScreen ? 16 : 30,
                                    zIndex: 99999999,
                                    color: '#fff',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0,0,0,0.95)',
                                    },
                                }}
                            >
                                <CloseRoundedIcon sx={{ fontSize: 30 }} />
                            </IconButton>

                            {isSmallScreen ? (
                                <Box
                                    sx={{
                                        position: 'fixed',
                                        inset: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        backgroundColor: '#000',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        overflow: 'hidden',
                                    }}
                                >
                                    {images.length > 1 && (
                                        <IconButton
                                            onClick={handlePrevImage}
                                            sx={{
                                                position: 'absolute',
                                                left: 10,
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 5,
                                                color: '#fff',
                                                backgroundColor: 'rgba(255,255,255,0.12)',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                                },
                                            }}
                                        >
                                            <ChevronLeftRoundedIcon />
                                        </IconButton>
                                    )}

                                    <div className='w-full h-full flex items-center justify-center px-10'>
                                        {images.length > 0 && (
                                            <img
                                                src={images[modalImageIndex]}
                                                alt=""
                                                className='max-w-full max-h-full object-contain'
                                            />
                                        )}
                                    </div>

                                    {images.length > 1 && (
                                        <IconButton
                                            onClick={handleNextImage}
                                            sx={{
                                                position: 'absolute',
                                                right: 10,
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                zIndex: 5,
                                                color: '#fff',
                                                backgroundColor: 'rgba(255,255,255,0.12)',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                                },
                                            }}
                                        >
                                            <ChevronRightRoundedIcon />
                                        </IconButton>
                                    )}
                                </Box>
                            ) : (
                                <Box sx={style}>
                                    <div className='w-full h-full flex items-center justify-center px-4 bg-white'>
                                        {images.length > 0 && (
                                            <ZoomableImage
                                                src={images[modalImageIndex]}
                                                alt=""
                                            />
                                        )}
                                    </div>
                                </Box>
                            )}
                        </>
                    </Modal>
                </section>

                <section>
                    <h1 className='font-bold text-lg text-teal-950'>{products.product?.seller?.businessDetails.businessName}</h1>
                    <p className='text-gray-500 font-semibold'>{products.product?.title}</p>

                    <div className='flex justify-between items-center py-2 border w-[220px] px-3 mt-5'>
                        <div className='flex flex-col items-center justify-center w-1/2'>
                            <div className='flex gap-1 items-center justify-center'>
                                <span>{avgRating ? avgRating.toFixed(1) : '–'}</span>
                                <StarIcon sx={{ color: teal[600], fontSize: "17px" }} />
                            </div>
                        </div>
                        <Divider orientation="vertical" flexItem />
                        <div className='flex items-center justify-center w-1/2'>
                            <span>{ratingCount} Ratings</span>
                        </div>
                    </div>

                    <div className='space-y-2'>
                        <div className='price flex items-center gap-3 mt-5 text-lg'>
                            <span className='font-semibold text-gray-800'> ₹{products.product?.sellingPrice}</span>
                            <span className='text thin-line-through text-gray-400 '>₹{products.product?.mrpPrice}</span>
                            <span className='text-[#00927c] font-semibold'>{products.product?.discountPercent}% off</span>
                        </div>
                        <p className='text-sm'>Inclusive of all taxes. Free Shipping above ₹999.</p>
                    </div>

                    <div className='mt-5'>
                        <p>{products.product?.description}</p>
                    </div>

                    <div className='mt-7 space-y-3'>
                        <div className='flex items-center gap-4'>
                            <ShieldIcon sx={{ color: teal[400] }} />
                            <p>Authentic & Quality Assured</p>
                        </div>

                        <div className='flex items-center gap-4'>
                            <WorkspacePremiumIcon sx={{ color: teal[400] }} />
                            <p>100% money back guarantee</p>
                        </div>

                        <div className='flex items-center gap-4'>
                            <LocalShippingIcon sx={{ color: teal[400] }} />
                            <p>Free Shipping & Returns (T&C Apply)</p>
                        </div>

                        <div className='flex items-center gap-4'>
                            <Wallet sx={{ color: teal[400] }} />
                            <p>Pay on delivery might be available</p>
                        </div>
                    </div>

                    <div className='mt-7 space-y-2'>
                        <h1>QUANTITY:</h1>
                        <div className=' flex items-center gap-2  w-[140px] justify-between'>
                            <Button disabled={quantity == 1} onClick={() => setQuantity(quantity - 1)} variant='outlined'>
                                <RemoveIcon />
                            </Button>
                            <span className='px-3 text-lg font-semibold'>
                                {quantity}
                            </span>
                            <Button onClick={() => setQuantity(quantity + 1)} variant='outlined'>
                                <AddIcon />
                            </Button>
                        </div>
                    </div>

                    <div className="mt-12 flex items-center gap-5">
                        <Button
                            onClick={handleAddCart}
                            sx={{ py: "1rem" }}
                            variant='contained' fullWidth startIcon={<AddShoppingCartIcon />}>
                            Add To Bag
                        </Button>
                        <Button
                            sx={{ py: "1rem" }}
                            variant='outlined' fullWidth startIcon={<FavoriteBorderIcon />} onClick={handleWishlist}>
                            Whishlist
                        </Button>
                    </div>

                    <div className="ratings w-full mt-10">
                        <h1 className="font-semibold text-lg pb-4">
                            Review & Ratings
                        </h1>

                        <div className='mt-10'>
                            <div className="space-y-5">
                                {review.reviews.map((item: any, i: number) => (
                                    <div key={i} className='space-y-5'>
                                        <ProductReviewCard item={item} />
                                        <Divider />
                                    </div>
                                ))}
                                <Button onClick={() => navigate(`/reviews/${productId}`)}>View All {review.reviews.length} Reviews</Button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <section className='mt-20'>
                <h1 className='text-lg font-bold'>Similar Product</h1>

                <div className='pt-5'>
                    <SmilarProduct />
                </div>
            </section>

            <Snackbar
                open={snackOpen}
                autoHideDuration={3000}
                onClose={handleSnackClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
            >
                <Alert onClose={handleSnackClose} severity={snackSeverity} variant="filled" sx={{ width: '100%' }}>
                    {snackMessage}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default ProductDetails